import { Card } from "@compass/core";
import { Comments } from "components";
import { Comment } from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentComments = (props: { initialLoad: boolean; id: number }) => {
  const [comments, setComments] = useState<Comment[]>();

  useEffect(() => {
    if (props.initialLoad) {
      getComments(props.id);
    }
  }, [props.initialLoad]);

  const getComments = (id: number) => {
    ApiService.students.getComments(id).then((response) => {
      setComments(response);
    });
  };

  const createComment = (comment: Comment) => {
    ApiService.students.saveCreateComment(props.id, comment).then((response) => {
      getComments(props.id);
    });
  };

  return (
    <Card>
      <Comments
        comments={comments}
        onCreateComment={(comment) => createComment(comment)}
        onSaved={() => getComments(props.id)}
      />
    </Card>
  );
};
